import { Body, Icon, IconType, Theme } from '@routific/hive';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

interface Props {
  onInviteClick: () => void;
}

const StyledDiv = styled.div`
  margin: 0;
  width:100%;
  padding: ${Theme.Spacing.smSpacing} ${Theme.Spacing.mdSpacing} ${Theme.Spacing.smSpacing} ${Theme.Spacing.mdSpacing};
  display:flex;
  align-items: center;
  user-select: none;
  color: ${Theme.Colors.primary5};
  .ant-typography-body{
    color: ${Theme.Colors.primary5};
  }
  gap:12px;
  :hover{
    background: ${Theme.Colors.primary2};
     cursor: pointer;
  }
  :active{
    background: ${Theme.Colors.primary3};
  }
`;

const InviteDriver: React.FC<Props> = ({ onInviteClick }) => {
  const { t } = useTranslation(['components']);

  return (
    <StyledDiv data-testid="invite-driver" onClick={onInviteClick}>
      <Icon icon={IconType.Email} />
      <Body>{t('driverListing.inviteButton')}</Body>
    </StyledDiv >
  );
};

export default InviteDriver;
